// extracted by mini-css-extract-plugin
module.exports = {"animatedBlock":"style_animatedBlock__1RUXi"};